export const SUBSCRIPTION_CONTROL_LINK_LABEL = 'backoffice.organizations.subscription_panel.control_link';

export const BILLING_DOCUMENTS_LINK_LABEL = 'backoffice.billing.documents.link';
